// KHAN-96/KHAN-16: ~139 console.log/console.debug/console.info calls are
// scattered across the codebase with no environment gating, so internal
// state/errors leak into the browser console in production. Rather than
// touching every call site (a much larger, riskier change), this silences
// all console noise in production builds only.
//
// KHAN-16 reopening: console.error/warn were originally left active in
// production "to catch real issues", but ~130 of those call sites
// (frontend/src/api/**) dump raw axios error objects - error.response.data,
// error.request, sometimes full backend error payloads - straight into any
// user's devtools console. That's a bigger information-leak risk than the
// debugging value of leaving them on in a build end users can inspect;
// production error visibility should go through real error tracking
// (Sentry or similar), not the browser console. So these are now gated too.
export default function disableConsoleInProduction() {
  if (process.env.NODE_ENV === "production") {
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};
    console.error = () => {};
    console.warn = () => {};
  }
}
